module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_c('span', {
    staticClass: "cic-I"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("nside the world of humans is the world of imagination, and the only way you can go there is through the door of your mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A girl called Tuesday asked her mother, “Who made the place that stories come from?”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Her mother thought for a moment, then said, “I think it began when the first person ever looked at a cloud and saw a wild beast. Or perhaps the first time a girl bent over a pond and saw a heroine in the reflection there. Or maybe when a boy first imagined himself walking into the forest and finding a feast. I know that long before stories were written down, they were spoken as whispers in the dark of winter, as tales at the fireside under a full moon, as songs to lull children to sleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“And I think it’s been going on for all this time, ever since then, world after world being created, growing, expanding until we could never know the scale of it all. It’s rather like the universe: the more we seek to find the boundaries, the larger it grows. Because the place stories come from holds everything we have ever feared or hoped or lived for, and when you think of how many people there have ever been, all of them hoping and fearing and living … well, that’s quite something.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caced76c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 69
// module chunks = 0